import * as React from 'react';
import { IAction } from '../merchant-interfaces';
import { merchantActionTypes } from '../action-types';

export const setConfirmAgreement = (dispatch: React.Dispatch<IAction>, isConfirmAgreement: boolean): void => {
  dispatch({ type: merchantActionTypes.SET_CONFIRM_AGREEMENT, payload: !isConfirmAgreement });
};